import { useState, useCallback } from "react";
import * as React from "react";
import GotoCheckMail from "../routing/components/redirects/GotoCheckMail";
import SignupService from "./SignupService";
import useInput from "../input/useInput";
import FormCard from "../form/FormCard";
import { SubmitFunction } from "../form/types";
import Page from "../layout/page/Page";
import Primary from "../layout/page/Primary";

const SignupForm: React.FC = () => {
    const [inputEmail, onInputChange] = useInput();
    const [isDone, setIsDone] = useState<boolean>();

    const onSubmitSuccess = useCallback(() => {
        setIsDone(true);
    }, [setIsDone]);

    const onSubmitClick: SubmitFunction = async () => {
        await SignupService.registerNewUser(inputEmail);
        return "Success";
    };

    if (isDone) {
        return <GotoCheckMail />;
    }

    return (
        <Page mode="dead-center">
            <Primary>
                <FormCard
                    legend="New account"
                    submitCaption="Signup"
                    onSubmit={onSubmitClick}
                    onSubmitSuccess={onSubmitSuccess}
                >
                    <label>
                        Enter your email address
                        <input
                            data-testid="email-input"
                            onChange={onInputChange}
                            placeholder="example@example.com"
                            required={true}
                            autoFocus={true}
                            type="email"
                            value={inputEmail}
                        />
                    </label>
                </FormCard>
            </Primary>
        </Page>
    );
};

export default SignupForm;
